'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './payment-list.routes';

export class PaymentListComponent {
  constructor(PaymentService, DTOptionsBuilder) {
    'ngInject';
    this.data = PaymentService.query();

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('order', [0, 'desc']);
  }
}

export default angular.module('conduuApp.paymentList', [uiRouter])
  .config(routes)
  .component('paymentList', {
    template: require('./payment-list.html'),
    controller: PaymentListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/payment/list/payment-list.component.js